<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect class="text-xIconBg" width="24" height="24" fill="currentColor"/>
    <path class="text-xIconColor" d="M17.2474 3H20.2162L13.7304 10.4128L21.3604 20.5H15.3862L10.7069 14.3822L5.35282 20.5H2.38231L9.31949 12.5712L2 3H8.1259L12.3555 8.59192L17.2474 3ZM16.2055 18.7231H17.8505L7.23205 4.68359H5.4668L16.2055 18.7231Z" fill="currentColor"/>
  </svg>
</template>